export default class SimpleTweener {
	constructor() {
		this.tweensSF = [];
	}

	update(delta) {
		for (var i = 0; i < this.tweensSF.length; i++) {
			if (this.tweensSF[i].complete) {
				this.tweensSF.splice(i, 1);
				i--;
			}
		}
		this.tweensSF.forEach(t => {
			t.update(delta);
		});
	}

	push(tween) {
		this.tweensSF.push(tween);
	}
}
